import { render, staticRenderFns } from "./settledBetCard.vue?vue&type=template&id=f482dd9a&scoped=true&"
import script from "./settledBetCard.vue?vue&type=script&lang=js&"
export * from "./settledBetCard.vue?vue&type=script&lang=js&"
import style0 from "./settledBetCard.vue?vue&type=style&index=0&id=f482dd9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f482dd9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
